import { WorkflowStatusName } from "../items";
import { PhaseStatusKinds } from "../kinds";
import { ReceptionDateTranslator } from "../ReceptionDateTranslator";

// 個々のWFフェーズ設定
export class WorkflowPhaseEditorModel {
  public correspondStatus: WorkflowStatusName;
  public limitDays: number;
  public limitDate: Date;
  public isEnable: boolean;
  public phaseStatus: PhaseStatusKinds;


  clone(): WorkflowPhaseEditorModel {
    const newObj = new WorkflowPhaseEditorModel();
    newObj.correspondStatus = this.correspondStatus.clone();
    newObj.limitDays = this.limitDays;
    newObj.limitDate = this.limitDate;
    newObj.isEnable = this.isEnable;
    newObj.phaseStatus = this.phaseStatus;

    return newObj;
  }

  static areEqual(source: WorkflowPhaseEditorModel, dest: WorkflowPhaseEditorModel) {

    const dateTranslator: ReceptionDateTranslator = new ReceptionDateTranslator();

    return (source === dest)
      || (source && dest
        && source.correspondStatus.code === dest.correspondStatus.code
        && source.limitDays === dest.limitDays
        && dateTranslator.toDateString(source.limitDate) === dateTranslator.toDateString(dest.limitDate)
        && source.isEnable === dest.isEnable
        && source.phaseStatus === dest.phaseStatus);
  }
}
